import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_forma_pagamento } from "../../../models";

export const FormaPagamento = () => {
    const columns = [
        { field: 'forpagdescricao', header: 'Descrição' },
        { field: 'conta.condescricao', header: 'Conta Padrão' },
        { field: 'forpagativo', header: 'Ativo' },
        { field: 'functions', style: { minWidth: '7rem', width: '7rem' } }
    ];

    return (
        <ConsultaPadrao model={model_forma_pagamento} columns={columns} />
    )
}